import { CookieSessionData } from '../../Models/CookieSessionData';
import { ModifyWorkspaceUsersState, UIRedirectSearchParams } from './Reducer';

export enum UIStateActions {
    SetAddUsers = 'UISTATE/AddUsers',
    SetHomeNavigate = 'UISTATE/AllowHomeNavigate',
    ChangePortalBusy = 'UISTATE/ChangePortalBusy',
    SetRedirectAfterLogin = 'UISTATE/RedirectAfterLogin',
    SetModifyWorkspaceUsersState = 'UISTATE/ModifyWorkspaceUsersState',
    UpdateLastUserInteraction = 'UISTATE/UpdateLastUserInteraction',
    UpdateUIStateTimer = 'UISTATE/UpdateStateTimer',
    SetShowDataCollectionLimitsDetails = 'UISTATE/SetShowDataCollectionLimitsDetails',
    SetUserIsAuthenticated = 'UISTATE/SetUserIsAuthenticated',
}

export interface ISetAddUsers {
    readonly type: UIStateActions.SetAddUsers;
    readonly isActive: boolean;
}

export interface IAllowHomeNavigate {
    readonly type: UIStateActions.SetHomeNavigate;
    readonly allow: boolean;
}

export interface IChangePortalBusy {
    readonly type: UIStateActions.ChangePortalBusy;
    readonly increment: number;
    readonly source: string;
}

export interface ISetRedirectAfterLogin {
    readonly type: UIStateActions.SetRedirectAfterLogin;
    readonly path?: string;
    readonly searchParams?: UIRedirectSearchParams;
}

export interface ISetModifyWorkspaceUsersState {
    type: UIStateActions.SetModifyWorkspaceUsersState;
    data?: ModifyWorkspaceUsersState;
}

export interface IUpdateLastUserInteraction {
    type: UIStateActions.UpdateLastUserInteraction;
}

export interface IUpdateUIStateTimer {
    type: UIStateActions.UpdateUIStateTimer;
    cookieSessionData: CookieSessionData;
}

export interface ISetShowDataCollectionLimitsDetails {
    type: UIStateActions.SetShowDataCollectionLimitsDetails;
    show: boolean;
}

export interface ISetUserIsAuthenticated {
    type: UIStateActions.SetUserIsAuthenticated;
    authenticated: boolean;
}

export type KnownAction =
    ISetAddUsers |
    IAllowHomeNavigate |
    IChangePortalBusy |
    ISetRedirectAfterLogin |
    ISetModifyWorkspaceUsersState |
    IUpdateLastUserInteraction |
    IUpdateUIStateTimer |
    ISetShowDataCollectionLimitsDetails |
    ISetUserIsAuthenticated;
